import React from "react";
import { MobileStepper } from "@mui/material";

const DSMobileStepper = (props: React.ComponentProps<typeof MobileStepper>) => {
  return <MobileStepper {...props} />;
};

export default DSMobileStepper;
